import { Session } from "@models/ISchema";
import { BlockRanges, EditedSession } from "../context/formData.reducer";
import { Week } from "@modules/sections/ISections";

const isEditedSession = (sessionOrEditedSession: Session | EditedSession): boolean => {
  const session = sessionOrEditedSession as EditedSession;
  return session?.isCloned !== undefined;
};

export const blocksFormat = (sessionOrEditedSession: Session | EditedSession): BlockRanges => {
  if (isEditedSession(sessionOrEditedSession)) {
    const editedSession = sessionOrEditedSession as EditedSession;
    const block = editedSession?.blocks;
    const selected = block?.selected;

    return {
      day: block?.day,
      days: block?.days,
      startTime: selected === "hours" ? block?.startTime : undefined,
      endTime: selected === "hours" ? block?.endTime : undefined,
      blocks: block?.blocks,
      selected,
    };
  }

  const session = sessionOrEditedSession as Session;
  const blockRange = session?.assignment?.blockRange;
  const isWithHours =
    blockRange?.start?.day && blockRange?.start?.startingTime && blockRange?.end?.endingTime
      ? true
      : false;

  return {
    day: blockRange?.start?.day,
    days: session?.assignment?.days ?? [],
    startTime: blockRange?.start?.startingTime,
    endTime: blockRange?.end?.endingTime,
    blocks: session?.blocksCount,
    selected: isWithHours ? "hours" : "blocks",
  };
};

export const intervalsFormat = (
  sessionOrEditedSession: Session | EditedSession,
  linkWeeks: Week[],
) => {
  if (isEditedSession(sessionOrEditedSession)) {
    return (sessionOrEditedSession as EditedSession)?.intervals;
  }

  const sessionWeeksById = (
    (sessionOrEditedSession as Session)?.assignment?.intervals || []
  ).reduce((acc: { [key: string]: boolean }, week) => ({ ...acc, [week.id]: true }), {});

  return (linkWeeks || []).map(week => ({
    ...week,
    checked: week.id in sessionWeeksById,
    highlight: false,
  }));
};
